<div class="d-flex justify-content-center cover-spin" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="flex-container" >
  <div class="horizontal-container m20 alignCenter">
    <div class="fullflex" (click)="selSection('Snapshot')" [ngClass]="selected == 'Snapshot' ? 'selected': ''">
      Snapshot
      <fa-icon [icon]="faInfoCircle" id="SnapshotInfoBtn" (mouseenter)="showHideInfoToggle('SnapshotInfo')" (mouseleave)="showHideInfoToggle('SnapshotInfo')"></fa-icon>
      <div id="divSnapshotInfo">
          <div class="InfoContent" >
            This selection will give you a detailed overview of the final report values for the solution selected.
          </div>
          <div id="arrow" style="margin-top:-87px;margin-left:65px;" data-popper-arrow ></div>
      </div>
    </div>
    <div class="fullflex" (click)="selSection('Comparison')" [ngClass]="selected == 'Comparison' ? 'selected': ''">
      Comparison
      <fa-icon [icon]="faInfoCircle" id="ComparisonInfoBtn" (mouseenter)="showHideInfoToggle('ComparisonInfo')" (mouseleave)="showHideInfoToggle('ComparisonInfo')"></fa-icon>
      <div id="divComparisonInfo" >
          <div class="InfoContent" >
            This selection will give you a table showing all the figures from each solution side by side. <br>
            Comparison is a quick way to see how the final report will look without having to generate it.
          </div>
          <div id="arrow" style="margin-top: -126px;margin-left: 120px;" data-popper-arrow > </div>
      </div>
    </div>
  </div>

  <div id="divsnapshot" style="display: flex; " class="vertical" *ngIf="selected == 'Snapshot'" >
    <div class="vertical-containers stageBox">
      <label>Select a solution</label>
      <div class="horizontal-container">
        <div class="tabs" *ngFor="let solution of astmSolutions" (click)="setState(solution.solutionID)"
            [ngClass]="state == solution.solutionID ? 'selected': ''">
            <span>{{solution.solutionName}}</span>
        </div>
    </div>
    </div>
  </div>

  <div id="divsnapshotsolution" style="display:flex; margin-top:2%;" class="vertical" *ngIf="selected == 'Snapshot'">
    <div class="section">
      <div class="solInfo">
        <span style="font-weight:bold; color:#00673E; font-size: large;">{{astmGasInfo.contaminationType}} , {{astmGasInfo.moreInformation.chemicalFormula}}</span>
      </div>
      <div style="padding-bottom: 10px;">
        <span style="color:#424446; font-weight:630;">Concentration &nbsp; : &nbsp; </span>
        <span style="color:#00673E; font-weight:620;">{{concResultDisplay}}</span>
      </div>
      <div>
        <span style="margin-left:5%;">Molecular Weight</span>
        <span style="padding-left:5px; padding-right:15px;">:</span>
        <span>{{astmGasInfo.moreInformation.molecularWeight}}&nbsp; g/mol</span>
      </div>
      <div>
        <span style="margin-left:5%;">Boiling Point</span>
        <span style="padding-left:36px; padding-right:15px;">:</span>
        <span>{{astmGasInfo.moreInformation.boilingPoint}} &nbsp; {{UnitsFromUserData.Temperature}}</span>
      </div>
      <div>
        <span style="margin-left:5%;">Vapour Pressure </span>
        <span style="padding-left:10px; padding-right:15px;">:</span>
        <span >{{vapourPressureDisplay}}</span>
      </div>
      <div>
        <span style="padding-left:173px;"> {{vapourPressuremmHg}}</span>
      </div>
      <div>
        <span style="margin-left:5%;">CAS No </span>
        <span style="padding-left:70px; padding-right:15px;">:</span>
        <span>{{astmGasInfo.moreInformation.casNo}} </span>
      </div>
      <div style="margin-top: 12%; margin-bottom: 3%;">
        <span style="text-decoration:underline; font-weight: 600; color: #333F48;">Operating Conditions and Time</span>
      </div>
      <div>
        <span>Air Flow</span>
        <span style="padding-left:115px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{projectService.projectdetails.contamination.airflow}} &nbsp; {{projectService.projectdetails.contamination.airflowUnit}}</span>
      </div>
      <div>
        <span>Running Time / year</span>
        <span style="padding-left:29px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{projectService.projectdetails.contamination.runningTime}} &nbsp; hours</span>
      </div>
      <div>
        <span>Total Air Volume </span>
        <span style="padding-left:52px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{totalAirVolume}}</span>
      </div>
      <div style="margin-top:2%">
        <span>Temperature </span>
        <span style="padding-left:78px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{projectService.projectdetails.contamination.temperature}} &nbsp; {{UnitsFromUserData.Temperature}}</span>
      </div>
      <div>
        <span>Relative Humidity </span>
        <span style="padding-left:42px;padding-right:20px;">:</span>
        <span class="runningcondvalue">{{projectService.projectdetails.contamination.relativeHumidity}} &nbsp; %</span>
      </div>
      <div style="margin-top:2%">
        <span>Atm Pressure </span>
        <span style="padding-left:70px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{atmPressureDisplay}}</span>
      </div>
      <!-- Modified by PP(2023-06-20) : Estimated Contamination Load - START-->
      <div style="margin-top:2%">
        <span>Estimated Contamination Load</span>
        <span style="padding-left:10px; padding-right:20px;">:</span>
        <span class="runningcondvalue">{{selectedAstmResult.contaminantPerYear}} &nbsp; {{weightUnit}}/year</span>
      </div>
      <!-- Modified by PP(2023-06-20) : Estimated Contamination Load - END--> 
    </div>

    <div class="section" style="width:65%;">
      <div>
        <span style="font-size:larger; font-weight:700; color:#9A9EA0;">
          Estimated Media Consumption according to ASTM D6646 methodology
          <fa-icon [icon]="faInfoCircle" id="SnapShotMediaConsumpInfoBtn" (mouseenter)="showHideInfoToggle('SnapShotMediaConsumptionInfo')" (mouseleave)="showHideInfoToggle('SnapShotMediaConsumptionInfo')"></fa-icon>
          <div id="divSnapShotMediaConsumpInfo">
              <div class="InfoContent">
                Note: The capacities are derived by following the procedure of the American Society for testing and Materials test method D6646-3 (2014) or estimated.
                      Other contaminants in the air will influence the filter performance .
                      <br><u>ASTM Section 5.1:</u> This test does not simulate actual conditions encountered in an odor control application.
                      <br><u>ASTM Section 5.2:</u> This test does not duplicate conditions that an adsorber would encounter in practical service.
                      <br>Disclaimer: This report and information is intended only for informational purposes and to assist with designing solutions. Camfil AB does not warrant the performance or results that may be obtained by using this information, nor are they a replacement for actual measurements or testing.
              </div>
              <div id="arrow" data-popper-arrow style="margin-top: 21px;margin-left: 600px;"></div>
          </div>
        </span>
      </div>
      <div style="margin-top:5%; margin-left:10%; margin-bottom:3%;">
        <span style="font-weight:bold; color:#00673E; font-size: large;">{{astmSolInfo.solutionDetails[0].filterName}}</span>
        <span ><img src="{{selectedAstmResult.mediaPicture}}" style="width:150px; height:120px; margin-left:5%;"></span>
      </div>
      <div style="margin-top:2%; width:60%; background:#F1F5F2;padding-bottom:15px;">
        <div style="margin-left:25%; margin-bottom:3%; margin-top:2%;">
          <span style="color:#00673E; font-size: larger; font-weight:600;">Estimated Media Consumption </span>
          <!-- <span style="padding-left:18px; padding-right:15px;">:</span> -->
          <!-- <span style="color:#00673E; font-size: larger; font-weight:600;">{{selectedAstmResult.contaminantPerYear}} &nbsp; {{weightUnit}}/year</span> -->
        </div>
        <div class="consumptionbymonth">
          <span>1 month </span>
          <span style="padding-left:43px; padding-right:15px;">:</span>
          <span>{{selectedAstmResult.mediaConsumption1Month}} &nbsp; {{weightUnit}}</span>
        </div>
        <div class="consumptionbymonth">
          <span>3 months </span>
          <span style="padding-left:36px; padding-right:15px;">:</span>
          <span>{{selectedAstmResult.mediaConsumption3Month}} &nbsp; {{weightUnit}}</span>
        </div>
        <div class="consumptionbymonth">
          <span>6 months </span>
          <span style="padding-left:36px; padding-right:15px;">:</span>
          <span>{{selectedAstmResult.mediaConsumption6Month}} &nbsp; {{weightUnit}}</span>
        </div>
        <div class="consumptionbymonth">
          <span style="font-weight:490; font-size:larger;color:#00673E;">12 months &nbsp; : &nbsp; {{selectedAstmResult.mediaConsumption12Month}} &nbsp; {{weightUnit}}</span>
        </div>
        <div class="consumptionbymonth">
          <span>24 months </span>
          <span style="padding-left:28px; padding-right:15px;">:</span>
          <span>{{selectedAstmResult.mediaConsumption24Month}} &nbsp; {{weightUnit}}</span>
        </div>
      </div>

    </div>

  </div>

  <div id="divComparison" *ngIf="selected == 'Comparison'">
    <table class="compareTable">
      <tr class="top" >
        <td></td>
        <td *ngIf="astmSolutions.length >=1">{{astmSolutions[0].solutionName}}</td>
        <td *ngIf="astmSolutions.length >=2">{{astmSolutions[1].solutionName}}</td>
        <td *ngIf="astmSolutions.length >=3">{{astmSolutions[2].solutionName}}</td>
      </tr>
      <tr>
        <td style="padding-top:15px;">Contamination Type</td>
        <td style="padding-top:15px;font-weight: 550;" *ngIf="astmParams.gasDetails.length >=1">{{astmParams.gasDetails[0].contaminationType}}</td>
        <td style="padding-top:15px;font-weight: 550;" *ngIf="astmParams.gasDetails.length >=2">{{astmParams.gasDetails[1].contaminationType}}</td>
        <td style="padding-top:15px;font-weight: 550;" *ngIf="astmParams.gasDetails.length >=3">{{astmParams.gasDetails[2].contaminationType}}</td>
      </tr>
      <tr>
        <td style="padding-left:30px;">- &nbsp;Formula</td>
        <td *ngIf="astmParams.gasDetails.length >=1">{{astmParams.gasDetails[0].moreInformation.chemicalFormula}}</td>
        <td *ngIf="astmParams.gasDetails.length >=2">{{astmParams.gasDetails[1].moreInformation.chemicalFormula}}</td>
        <td *ngIf="astmParams.gasDetails.length >=3">{{astmParams.gasDetails[2].moreInformation.chemicalFormula}}</td>
      </tr>
      <tr>
        <td style="padding-left:30px;">- &nbsp;Molecular Weight</td>
        <td *ngIf="astmParams.gasDetails.length >=1">{{molecularWeightDisplay1}}</td>
        <td *ngIf="astmParams.gasDetails.length >=2">{{molecularWeightDisplay2}}</td>
        <td *ngIf="astmParams.gasDetails.length >=3">{{molecularWeightDisplay3}}</td>
      </tr>
      <tr>
        <td style="padding-left:30px;">- &nbsp;CAS No</td>
        <td *ngIf="astmParams.gasDetails.length >=1">{{astmParams.gasDetails[0].moreInformation.casNo}}</td>
        <td *ngIf="astmParams.gasDetails.length >=2">{{astmParams.gasDetails[1].moreInformation.casNo}}</td>
        <td *ngIf="astmParams.gasDetails.length >=3">{{astmParams.gasDetails[2].moreInformation.casNo}}</td>
      </tr>
      <tr>
        <td style="padding-top:20px;">Concentration</td>
        <!-- <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=1">{{astmParams.gasDetails[0].concentrationValue}}&nbsp;{{projectService.projectdetails.projectInfo.concUnit}}</td>
        <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=2">{{astmParams.gasDetails[1].concentrationValue}}&nbsp;{{projectService.projectdetails.projectInfo.concUnit}}</td>
        <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=3">{{astmParams.gasDetails[2].concentrationValue}}&nbsp;{{projectService.projectdetails.projectInfo.concUnit}}</td> -->
        <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=1">{{arrConcforMainUnit[0]}}</td>
        <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=2">{{arrConcforMainUnit[1]}}</td>
        <td style="padding-top:20px;" *ngIf="astmParams.gasDetails.length >=3">{{arrConcforMainUnit[2]}}</td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td *ngIf="astmParams.gasDetails.length >=1">{{arrConcfor2ndUnit[0]}}</td>
        <td *ngIf="astmParams.gasDetails.length >=2">{{arrConcfor2ndUnit[1]}}</td>
        <td *ngIf="astmParams.gasDetails.length >=3">{{arrConcfor2ndUnit[2]}}</td>
      </tr>
      <tr>
        <td style="padding-top:20px;">Contaminant</td>
        <td style="padding-top:20px;color:#00673E; font-weight: 550;" *ngIf="results.length >=1">{{results[0].astmResults.contaminantPerYear}}&nbsp;{{weightUnit}}/year</td>
        <td style="padding-top:20px;color:#00673E; font-weight: 550;" *ngIf="results.length >=2">{{results[1].astmResults.contaminantPerYear}}&nbsp;{{weightUnit}}/year</td>
        <td style="padding-top:20px;color:#00673E; font-weight: 550;" *ngIf="results.length >=3">{{results[2].astmResults.contaminantPerYear}}&nbsp;{{weightUnit}}/year</td>
      </tr>
      <tr>
        <td style="padding-top:20px;">Media</td>
        <td style="padding-top:20px;font-weight: 550;" *ngIf="astmSolutions.length >=1">{{astmSolutions[0].solutionDetails[0].filterName}}</td>
        <td style="padding-top:20px;font-weight: 550;" *ngIf="astmSolutions.length >=2">{{astmSolutions[1].solutionDetails[0].filterName}}</td>
        <td style="padding-top:20px;font-weight: 550;" *ngIf="astmSolutions.length >=3">{{astmSolutions[2].solutionDetails[0].filterName}}</td>
      </tr>
      <tr>
        <td style="padding-left:30px;">&nbsp;-&nbsp;Capacity by Weight</td>
        <td *ngIf="astmSolutions.length >=1">{{astmSolutions[0].solutionDetails[0].astmWeight}}&nbsp;%</td>
        <td *ngIf="astmSolutions.length >=2">{{astmSolutions[1].solutionDetails[0].astmWeight}}&nbsp;%</td>
        <td *ngIf="astmSolutions.length >=3">{{astmSolutions[2].solutionDetails[0].astmWeight}}&nbsp;%</td>
      </tr>
      <tr>
        <td style="padding-left:30px; padding-bottom: 30px;">&nbsp;-&nbsp;Capacity by Volume</td>
        <td style="padding-bottom: 30px;" *ngIf="astmSolutions.length >=1">{{astmSolutions[0].solutionDetails[0].astmvolume}}&nbsp;%</td>
        <td style="padding-bottom: 30px;" *ngIf="astmSolutions.length >=2">{{astmSolutions[1].solutionDetails[0].astmvolume}}&nbsp;%</td>
        <td style="padding-bottom: 30px;" *ngIf="astmSolutions.length >=3">{{astmSolutions[2].solutionDetails[0].astmvolume}}&nbsp;%</td>
      </tr>
      <tr>
        <td colspan="4" class="compareMediaConsumptionHeader" >
          Estimated Media Consumption according to ASTM D6646 methodology
          <fa-icon [icon]="faInfoCircle" id="MediaConsumpInfoBtn" (mouseenter)="showHideInfoToggle('MediaConsumptionInfo')" (mouseleave)="showHideInfoToggle('MediaConsumptionInfo')"></fa-icon>
          <div id="divMediaConsumpInfo">
              <div class="InfoContent">
                Note: The capacities are derived by following the procedure of the American Society for testing and Materials test method D6646-3 (2014) or estimated.
                      Other contaminants in the air will influence the filter performance .
                      <br><u>ASTM Section 5.1:</u> This test does not simulate actual conditions encountered in an odor control application.
                      <br><u>ASTM Section 5.2:</u> This test does not duplicate conditions that an adsorber would encounter in practical service.
                      <br>Disclaimer: This report and information is intended only for informational purposes and to assist with designing solutions. Camfil AB does not warrant the performance or results that may be obtained by using this information, nor are they a replacement for actual measurements or testing.
              </div>
              <div id="arrow" data-popper-arrow style="margin-top: 21px;"></div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="padmediaConsump">1 Month</td>
        <td class="padmediaConsump" *ngIf="results.length >=1">{{results[0].astmResults.mediaConsumption1Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=2">{{results[1].astmResults.mediaConsumption1Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=3">{{results[2].astmResults.mediaConsumption1Month}}&nbsp;{{weightUnit}}</td>
      </tr>
      <tr>
        <td class="padmediaConsump">3 Months</td>
        <td class="padmediaConsump" *ngIf="results.length >=1">{{results[0].astmResults.mediaConsumption3Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=2">{{results[1].astmResults.mediaConsumption3Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=3">{{results[2].astmResults.mediaConsumption3Month}}&nbsp;{{weightUnit}}</td>
      </tr>
      <tr>
        <td class="padmediaConsump">6 Months</td>
        <td class="padmediaConsump" *ngIf="results.length >=1">{{results[0].astmResults.mediaConsumption6Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=2">{{results[1].astmResults.mediaConsumption6Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=3">{{results[2].astmResults.mediaConsumption6Month}}&nbsp;{{weightUnit}}</td>
      </tr>
      <tr>
        <td class="padmediaConsump" style="color:#00673E; font-weight: 550;">12 Months</td>
        <td class="padmediaConsump" style="color:#00673E; font-weight: 550;" *ngIf="results.length >=1">{{results[0].astmResults.mediaConsumption12Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" style="color:#00673E; font-weight: 550;" *ngIf="results.length >=2">{{results[1].astmResults.mediaConsumption12Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" style="color:#00673E; font-weight: 550;" *ngIf="results.length >=3">{{results[2].astmResults.mediaConsumption12Month}}&nbsp;{{weightUnit}}</td>
      </tr>
      <tr>
        <td class="padmediaConsump">24 Months</td>
        <td class="padmediaConsump" *ngIf="results.length >=1">{{results[0].astmResults.mediaConsumption24Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=2">{{results[1].astmResults.mediaConsumption24Month}}&nbsp;{{weightUnit}}</td>
        <td class="padmediaConsump" *ngIf="results.length >=3">{{results[2].astmResults.mediaConsumption24Month}}&nbsp;{{weightUnit}}</td>
      </tr>
     <!-- <tr>
      <td  colspan="4">Estimated Media Consumption according to ASTM D6646 methodology</td>
     </tr> -->
    </table>
  </div>

  <div class="next-button-content" style="margin-top:2%;">
    <button class="button-content ripple" (click)='next()'>
        <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
    </button>
  </div>

</div>
